<div class="button" [class.turnedOn]="turnedOn" [class.disabled]="disabled" (click)="toggle.emit()">
  @if (!matIcon && !svgIcon()) {
    <div
      [ngClass]="icon"
      class="icon"
    ></div>
  }
  @if (matIcon) {
    <mat-icon [fontSet]="fontSet" [fontIcon]="matIcon"></mat-icon>
  }
  @if (svgIcon()) {
    <mat-icon [svgIcon]="svgIcon()"></mat-icon>
  }
</div>
